export function printBarcodes({ barcodeHtml, quantity = 1, text = '' }) {
  if (!barcodeHtml || quantity < 1) return;

  let content = '';
  for (let i = 0; i < quantity; i++) {
    content += `
      <div class="page">
        <div class="barcode-wrapper">
          <span style="font-size:10px; margin-bottom:2px;">${text}</span>
          <div class="barcode-img">${barcodeHtml}</div>
        </div>
      </div>
    `;
  }

  const printWindow = window.open();
  printWindow.document.write(`
    <html>
      <head>
        <title>Print Barcode</title>
        <style>
          @page { size: 1.5in 0.6in; margin: 0; }
          body { margin: 0; padding: 0; font-family: Arial, sans-serif; }

          /* Page container */
          .page { 
            display: flex; 
            flex-direction: column; 
            align-items: center; 
            justify-content: center; 
            page-break-after: always;
            box-sizing: border-box;
          }

          /* Wrapper to keep text + barcode together */
          .barcode-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          /* Barcode image */
          .barcode-img svg {
            width: 100%;
            height: auto; /* preserves aspect ratio */
          }
        </style>
      </head>
      <body>
        ${content}
        <script>
          window.onload = function() {
            window.focus();
            window.print();
            window.close();
          };
        <\/script>
      </body>
    </html>
  `);
  printWindow.document.close();
}
